import Toolbar from 'react-multi-date-picker/plugins/toolbar';
import styled from 'styled-components';

export const  StyledToobar= styled(Toolbar)`
  & div:nth-child(2){
      display:none;
  }
  & div{
      flex-grow:1;
      margin:3px 5px;
  }
`;